import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService, { type IResponse } from 'services/dataService';
import { apiAssignTask } from 'services/dataService/resources/oneplatform/api';

import { QUERY_KEYS } from '../constants';

export function useAssignDashboardTask() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (taskGuid: string) =>
      dataService.createOne(apiAssignTask(taskGuid), {}),
    onSuccess: (response: IResponse<unknown>) => {
      if (response.error) {
        const errorMessage =
          response.status === 409
            ? t('tasksDashboard.assignConflictError')
            : t('tasksDashboard.assignError');
        notificationController.error({
          message: errorMessage,
        });
        if (response.status === 409) {
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.dashboardTasks],
            exact: false,
            refetchType: 'active',
          });
        }
        return;
      }

      notificationController.success({
        message: t('tasksDashboard.assignSuccess'),
      });
      queryClient.invalidateQueries([QUERY_KEYS.dashboardTasks]);
      queryClient.invalidateQueries([QUERY_KEYS.tasksBadgeCount]);
    },
  });
}
